import GradientBg from "../components/GradietBg";
import CheckMarkThinIcon from "../../public/checkMarkThin.svg?react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import WalletIcon from "../../public/wallet.svg?react";
import { getMobileOperatingSystem } from "../common/platform";
import { useTranslation } from "../i18n";

const platform2url = {
  IOS: "shoebox://",
  Android: "https://wallet.google",
};

/**
 * @param {object} props
 * @param {"success" | "failure"} props.status
 * @returns {React.Component}
 */
export default function PaymentStatus({ status }) {
  const { t } = useTranslation();
  let walletUrl = platform2url[getMobileOperatingSystem()];
  let paymentSucceed = status === "success";

  return (
    <GradientBg className="h-dvh">
      <div className="h-full flex flex-col items-center justify-center px-4 pb-8">
        <span className="flex-grow" />
        {paymentSucceed ? (
          <div
            className={`w-20 h-20 mb-16 p-2 rounded-full border border-2 flex items-center justify-center border-[#66DA5C]`}
          >
            <CheckMarkThinIcon
              className="h-10 w-auto"
              stroke="#66DA5C"
              strokeWidth="2"
            />
          </div>
        ) : (
          <div
            className={`w-20 h-20 mb-16 p-2 rounded-full border border-2 flex items-center justify-center border-[#FF5453]`}
          >
            <XMarkIcon
              className="h-10 w-auto"
              stroke="#FF5453"
              strokeWidth="1"
            />
          </div>
        )}
        <h1 className="text-2xl text-center font-semi-bold">
          {paymentSucceed ? t("payment.success") : t("payment.failure")}
        </h1>
        <p className="mt-4 text-gray-200 text-center text-sm">
          {paymentSucceed ? (
            <>
              {t("payment.minutesCredited")}{" "}
              <a className="underline" href={platform2url["IOS"]}>
                Apple Wallet
              </a>{" "}
              или{" "}
              <a className="underline" href={platform2url["Android"]}>
                Google Pay
              </a>
            </>
          ) : (
            t("payment.retry")
          )}
        </p>
        <span className="flex-grow" />

        {paymentSucceed && walletUrl && (
          <a href={walletUrl} className="bg-white rounded-lg px-3 py-2 w-full">
            <div className="flex items-center justify-center space-x-2">
              <WalletIcon className="h-3 xl:h-6 w-3 xl:w-6" />
              <p className="text-accent">{t("payment.openInWallet")}</p>
            </div>
          </a>
        )}
      </div>
    </GradientBg>
  );
}
